import { render, staticRenderFns } from "./KvmDockerPairing.vue?vue&type=template&id=c0be95e2&scoped=true&"
import script from "./KvmDockerPairing.vue?vue&type=script&lang=js&"
export * from "./KvmDockerPairing.vue?vue&type=script&lang=js&"
import style0 from "./KvmDockerPairing.vue?vue&type=style&index=0&id=c0be95e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0be95e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0be95e2')) {
      api.createRecord('c0be95e2', component.options)
    } else {
      api.reload('c0be95e2', component.options)
    }
    module.hot.accept("./KvmDockerPairing.vue?vue&type=template&id=c0be95e2&scoped=true&", function () {
      api.rerender('c0be95e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmDockerPairing.vue"
export default component.exports